import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import ContractorName from "../../components/contractor/ContractorDetail/ContractorName.tsx";
import {useLocationFormState} from "../../components/contractor/ContractorForm/ContractorUpdateForm";
import ContractorUpdateFormProvider from "../../components/contractor/ContractorForm/ContractorUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ContractorUpdateEditPage = () => {
    
    useTitle(t`Update Contractor`);

    const { contractorId: id } = useParams();
    
    return (
        <Box data-testid="Contractor-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="Contractor-update-title"
                    >
                        <Trans>Edit Contractor</Trans>:  <ContractorName id={id}/>
                    </Typography>
                    <ContractorUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default ContractorUpdateEditPage;
